module.exports = __webpack_public_path__ + "static/media/newspaper.06161a6e.svg";